import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sustainabilityIconImageAlt: {
    defaultMessage: 'Nachhaltigkeit',
    description: 'sustainability icon image alt text',
    id: 'sustainabilityIcon.image.alt',
  },
  sustainabilityIconTitle: {
    defaultMessage: 'Was bedeutet dieses Zeichen?',
    description: 'sustainability icon title',
    id: 'sustainabilityIcon.title',
  },
});
